import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";

import AppTemplate from "../../component/app-template";
import { Styles } from "./styles";

const AttendanceRecordsPage = () => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchRecords = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await axios.get(
        "https://zczduwvikuodiuosrjye.supabase.co/functions/v1/get-all"
      );
      const payload = response?.data;
      
      setRecords(payload?.attendances);
    } catch (err) {
      console.error("Attendance fetch error", err);
      setError("تعذّر تحميل بيانات الحضور. حاول مجددًا.");
      setRecords([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchRecords();
  }, [fetchRecords]);

  return (
    <AppTemplate
      pageTitle="attendanceRecords.title"
      navbar={true}
      footer={true}
      footerBackgroundColor="#0b1a2c"
    >
      <Styles>
        <div className="page-header">
          <div>
            <h1>سجل الحضور</h1>
            <p>عرض جميع الأسماء المسجّلة للفعالية.</p>
          </div>
          <button type="button" onClick={fetchRecords} disabled={loading}>
            {loading ? "جاري التحديث..." : "تحديث القائمة"}
          </button>
        </div>

        {error && <p className="error-message">{error}</p>}

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>الاسم</th>
                
                
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={4} className="loading-cell">
                    جارٍ تحميل القائمة...
                  </td>
                </tr>
              ) : records?.length === 0 ? (
                <tr>
                  <td colSpan={4} className="empty-cell">
                    لا توجد بيانات حضور حتى الآن.
                  </td>
                </tr>
              ) : (
                records?.map((record, index) => (
                  <tr key={`${record?.id ?? record?.name ?? index}-${index}`}>
                    {console.log(record)}
                    <td>{index + 1}</td>
                    <td>{record?.name || "—"}</td>
                    {/* <td>{record?.mobileNumber || "—"}</td> */}
                    
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </Styles>
    </AppTemplate>
  );
};

export default AttendanceRecordsPage;
